

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';

const statesWithCities = {
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur"],
  "Arunachal Pradesh": ["Itanagar", "Tawang", "Ziro"],
  "Assam": ["Guwahati", "Dibrugarh", "Silchar"],
  "Bihar": ["Araria",
    "Arwal",
    "Aurangabad",
    "Banka",
    "Begusarai",
    "Bhagalpur",
    "Bhojpur",
    "Buxar",
    "Darbhanga",
    "East Champaran",
    "Gaya",
    "Gopalganj",
    "Jamui",
    "Jehanabad",
    "Kaimur",
    "Katihar",
    "Khagaria",
    "Kishanganj",
    "Lakhisarai",
    "Madhepura",
    "Madhubani",
    "Munger",
    "Muzaffarpur",
    "Nalanda",
    "Nawada",
    "Patna",
    "Purnia",
    "Rohtas",
    "Saharsa",
    "Samastipur",
    "Saran",
    "Sheikhpura",
    "Sheohar","Sitamarhi",
    "Siwan",
    "Supaul",
    "Vaishali",
    "West Champaran"],
  "Chhattisgarh": ["Raipur", "Bhilai", "Korba"],
  "Goa": ["Panaji", "Margao", "Vasco da Gama"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara"],
  "Haryana": ["Chandigarh", "Gurgaon", "Faridabad"],
  "Himachal Pradesh": ["Shimla", "Dharamshala", "Mandi"],
  "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad"],
  "Karnataka": ["Bengaluru", "Mysuru", "Mangaluru"],
  "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior"],
  "Maharashtra": ["Mumbai", "Pune", "Nagpur"],
  "Manipur": ["Imphal", "Thoubal", "Churachandpur"],
  "Meghalaya": ["Shillong", "Tura", "Nongstoin"],
  "Mizoram": ["Aizawl", "Lunglei", "Champhai"],
  "Nagaland": ["Kohima", "Dimapur", "Mokokchung"],
  "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela"],
  "Punjab": ["Ludhiana", "Amritsar", "Jalandhar"],
  "Rajasthan": ["Jaipur", "Udaipur", "Jodhpur"],
  "Sikkim": ["Gangtok", "Namchi", "Geyzing"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai"],
  "Telangana": ["Hyderabad", "Warangal", "Nizamabad"],
  "Tripura": ["Agartala", "Udaipur", "Dharmanagar"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi"],
  "Uttarakhand": ["Dehradun", "Haridwar", "Rishikesh"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur"],
  "Andaman and Nicobar Islands": ["Port Blair"],
  "Chandigarh": ["Chandigarh"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Daman", "Silvassa"],
  "Delhi": ["New Delhi", "Dwarka", "Rohini"],
  "Jammu and Kashmir": ["Srinagar", "Jammu"],
  "Ladakh": ["Leh", "Kargil"],
  "Lakshadweep": ["Kavaratti"],
  "Puducherry": ["Pondicherry", "Karaikal", "Yanam"],
};

const BuyNowPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const product = location.state?.product;

  const [step, setStep] = useState('address');
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    country: '',
  });

  const [hasPaid, setHasPaid] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Reset city if state changes
    if (name === "state") {
      setFormData((prev) => ({ ...prev, state: value, city: '' }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAddressSubmit = (e) => {
    e.preventDefault();
    setStep('payment');
  };

  const handlePaymentConfirmation = async () => {
    try {
      setSubmitting(true);
      const orderData = {
        ...formData,
        productName: product.name,
        productPrice: product.price,
      };

      const response = await fetch('https://portfolioback-nu.vercel.app/api/address', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to save order');
      }

      setHasPaid(true);
    } catch (err) {
      alert(`Error saving your order: ${err.message}`);
      console.error('Save order error:', err);
    } finally {
      setSubmitting(false);
    }
  };

  if (!product) {
    return (
      <div style={{ padding: 20 }}>
        <h2>Product not found.</h2>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const cityOptions = formData.state ? statesWithCities[formData.state] || [] : [];

  return (
    <div style={{ padding: 30, maxWidth: 600, margin: 'auto' }}>
      {step === 'address' && (
        <>
          <h1 className="text-danger text-center">
            ⚠️ Don't Pay Any Money — This Website is for Testing
          </h1>
          <p className="text-warning text-center">
            ⚠️ This is a test order. No real payment has been processed. SO don't Pay Any Money
          </p>
          <h2>Delivery Details</h2>

          <form onSubmit={handleAddressSubmit} className="container-fluid p-4 bg-light rounded shadow">
            <h4 className="mb-4 text-center text-primary">Enter Your Delivery Information</h4>

            <div className="form-group mb-3 text-dark">
              <label>Full Name</label>
              <input
                type="text"
                name="fullName"
                className="form-control"
                placeholder="Full Name"
                onChange={handleInputChange}
                value={formData.fullName}
                required
              />
            </div>

            <div className="form-group mb-3 text-dark">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                className="form-control"
                placeholder="Phone Number"
                onChange={handleInputChange}
                value={formData.phone}
                required
              />
            </div>

            <div className="form-group mb-3 text-dark">
              <label>Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email"
                onChange={handleInputChange}
                value={formData.email}
                required
              />
            </div>

            <div className="form-group mb-3 text-dark">
              <label>Full Address</label>
              <textarea
                name="address"
                className="form-control"
                placeholder="Address"
                rows="3"
                onChange={handleInputChange}
                value={formData.address}
                required
              ></textarea>
            </div>

            <div className="row">
              <div className="form-group col-md-6 mb-3 text-dark">
                <label>State</label>
                <select
                  name="state"
                  className="form-control"
                  onChange={handleInputChange}
                  value={formData.state}
                  required
                >
                  <option value="">Select a State</option>
                  {Object.keys(statesWithCities).map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group col-md-6 mb-3 text-dark">
                <label>City</label>
                <select
                  name="city"
                  className="form-control"
                  onChange={handleInputChange}
                  value={formData.city}
                  required
                  disabled={!formData.state}
                >
                  <option value="">Select a City</option>
                  {cityOptions.map((city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row">
              <div className="form-group col-md-6 mb-3 text-dark">
                <label>Pincode</label>
                <input
                  type="text"
                  name="pincode"
                  className="form-control"
                  placeholder="Pincode"
                  onChange={handleInputChange}
                  value={formData.pincode}
                  required
                />
              </div>
              <div className="form-group col-md-6 mb-3 text-dark">
                <label>Country</label>
                <input
                  type="text"
                  name="country"
                  className="form-control"
                  placeholder="Country"
                  onChange={handleInputChange}
                  value={formData.country}
                  required
                />
              </div>
            </div>

            <div className="text-center">
              <button type="submit" className="btn btn-primary px-4 py-2 mt-3">
                Proceed to Payment
              </button>
            </div>
          </form>
        </>
      )}

      {step === 'payment' && !hasPaid && (
        <>
          <h1 className="text-danger text-center">Don't Pay Any Money — This Website is for Testing</h1>

          <h2>Confirm Your Payment</h2>
          <p>Scan this UPI QR code to complete payment for:</p>
          <h3>
            {product.name} — ₹{product.price}
          </h3>

          {(() => {
            const upiId = 'gyasuddinali@cnrb';
            const note = `Payment for ${product.name}`;
            const upiUrl = `upi://pay?pa=${upiId}&pn=YourShop&am=${product.price}&cu=INR&tn=${encodeURIComponent(
              note
            )}`;

            return (
              <div style={{ textAlign: 'center' }}>
                <QRCodeSVG value={upiUrl} size={200} />
                <br />
                <a href={upiUrl}>
                  <button style={{ marginTop: 20 }}>Open UPI App</button>
                </a>
              </div>
            );
          })()}

          <button onClick={handlePaymentConfirmation} style={{ marginTop: 20 }} disabled={submitting}>
            {submitting ? 'Processing...' : 'I Have Paid'}
          </button>
        </>
      )}

      {hasPaid && (
        // <>
        //   <h1 className="text-danger text-center">⚠️Don't Pay Any Money — This Website is for Testing</h1>
        //   <p className="text-warning text-center">
        //     ⚠️ This is a test order. No real payment has been processed.SO don't Pay Any Money
        //   </p>
        //   <h2>Order Placed 🎉</h2>
        //   <p>
        //     Thank you, <strong>{formData.fullName}</strong>!
        //   </p>
        //   <p>
        //     Your <strong>{product.name}</strong> will be shipped to:
        //   </p>
        //   <p>
        //     {formData.address}, {formData.city}, {formData.state} - {formData.pincode},{' '}
        //     {formData.country}
        //   </p>
        //   <p>
        //     <strong>Total:</strong> ₹{product.price}
        //   </p>
        //   <button onClick={() => navigate('/')} className="btn btn-success mt-3">
        //     Back to Home
        //   </button>
        // </>






<>
  <div className="text-center p-4 border rounded shadow-sm bg-light text-dark">
    <h1 className="text-success mb-3">
      ✅ Payment Successful!Partially
    </h1>
    <p className="text-danger fw-bold">
      ⚠️ Don't Pay Any Money — This Website is for Testing
    </p>
    <p className="text-warning mb-4">
      This is a test order. No real payment has been processed.
    </p>

    <h2 className="mb-4">Order Placed 🎉</h2>

    <p className="lead">
      Thank you, <strong>{formData.fullName}</strong>!
    </p>

    <div className="text-start mx-auto" style={{ maxWidth: 400 }}>
      <h5>Shipping Address:</h5>
      <address className="mb-3">
        {formData.address}<br />
        {formData.city}, {formData.state} - {formData.pincode}<br />
        {formData.country}
      </address>

      <h5>Product:</h5>
      <p className="mb-3">
        <strong>{product.name}</strong><br />
        <strong>Total Paid:</strong> ₹{product.price}
      </p>
    </div>

    <button onClick={() => navigate('/')} className="btn btn-primary mt-3 px-4">
      Back to Home
    </button>
  </div>
</>





      )}
    </div>
  );
};

export default BuyNowPage;
